module.exports = __webpack_public_path__ + "static/media/avc_oxi.aed4cb34.svg";